var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exam-header-timer"},[_c('p',[_vm._v(" 残り "),_c('span',{class:{ 'color-alert': _vm.isNotification }},[_vm._v(_vm._s(_vm.min)+":"+_vm._s(_vm.secFormat(_vm.sec)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }